import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/fridge-not-cooling-repair", label: "Fridge Not Cooling" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
  { to: "/fridge-water-leak-repair", label: "Water Leak Repair" },
  { to: "/freezer-cooling-issue", label: "Freezer Cooling Issue" },
];

const FridgeIceBuildupRepair = () => {
  return (
    <FridgePageTemplate
      title="Fridge Ice Buildup Repair in Bangalore"
      description="Professional refrigerator ice buildup repair in Bangalore for defrost, thermostat, and drain issues."
      keywords="fridge ice buildup repair bangalore, refrigerator frost buildup service, fridge defrost repair"
      path="/fridge-ice-buildup-repair"
      bannerTitle="Fridge Ice Buildup Repair"
      intro={
        <>
          Ice buildup in your fridge can block vents, reduce cooling, and cause water leaks. Our Bangalore team fixes defrost systems, drainage, and thermostat faults fast.
        </>
      }
      highlights={[
        "Defrost heater and thermostat inspection",
        "Drain pan and drain line clearing",
        "Evaporator fan and airflow checks",
        "Ice and frost removal service",
      ]}
      issues={[
        "Frost buildup in freezer or fridge",
        "Clogged drain lines",
        "Continuous defrost cycle failure",
        "Fridge temperature fluctuations",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default FridgeIceBuildupRepair;

